import React from 'react';
import styled, { css } from 'styled-components';

import Text from 'shell/components/Text';

const Label = ({ ...rest }) => {
    return <StyledText forwardedAs={'label'} variant={'body2'} {...rest} />;
};

const StyledText = styled(Text)`
    color: ${(props) => props.theme.palette.neutral['900']};
    cursor: pointer;

    ${(props) =>
        props.disabled &&
        css`
            color: ${(props) => props.theme.palette.neutral['600']};

            && {
                cursor: default;
            }
        `}
`;

export default Label;
